import { ReactNode, useEffect, useState } from "react";

/**
 * Client-side only wrapper component.
 * Prevents hydration mismatches when rendering client-specific features (like icons/portal).
 */
export function ClientOnly({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted ? <>{children}</> : <>{fallback}</>;
}
